<template>
  <div>
    <HeaderGestion/>
    <SubHeaderConfig
      nombreGestion="Gestión Catastro"
      nivelPrevio=""
    />
    <FormCatastro/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderConfig from '../components/SubHeaderConfig.vue'
import FormCatastro from '../components/FormCatastro.vue'
export default {
  components: { HeaderGestion, SubHeaderConfig, FormCatastro },
  name: 'GestionCatastro'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
